import * as Yup from 'yup';

// Define a reusable plan config schema
const PlanConfigSchema = Yup.object().shape({
  planPrice: Yup.number().required('Plan price is required').positive('Must be a positive number'),
  planCredits: Yup.number().required('Plan credits are required').positive('Must be a positive number').integer('Must be a whole number').min(0, 'Must be a whole number'),
  users: Yup.number().required('Users information is required').positive('Must be a positive number')
  .integer('Must be a whole number'),
  cloudStorage: Yup.number().required('Cloud storage information is required').positive('Must be a positive number')
  .integer('Must be a whole number'),
  speechToText: Yup.boolean().default(false),
  aiServices: Yup.boolean().default(false),
  showPublic: Yup.boolean().default(false),
});

export const PricingFormSchema = Yup.object().shape({
  plans: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Plan name is required'),
      planDesc: Yup.string().required('Plan description is required'),
      monthly: PlanConfigSchema,
      yearly: PlanConfigSchema
    })
  )
});
